import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const ResetPasswordRequestDtoSchema = z.object({
  password: z.string(),
  token: z.string(),
});

const ResetPasswordResponseDtoSchema = z.string();

export type ResetPasswordRequestDto = z.infer<
  typeof ResetPasswordRequestDtoSchema
>;
export type ResetPasswordResponseDto = z.infer<
  typeof ResetPasswordResponseDtoSchema
>;

export const resetPassword = (
  dto: ResetPasswordRequestDto,
  config?: AxiosRequestConfig<ResetPasswordRequestDto>
) => {
  const data = ResetPasswordRequestDtoSchema.parse(dto);
  return api
    .post('/auth/reset-password', data, config)
    .then(responseContract(ResetPasswordResponseDtoSchema));
};
